<template>
  <section class="partner" id="partner">
    <div class="container">
      <div class="row mx-auto">
        <div class="col-12 col-lg-4 order-last order-lg-1 slide-in from-left">
          <div class="logo">
            <img src="../../../assets/images/partners_logo_new.png" alt="Logo von Tigi">
          </div>
        </div>
        <div class="col-12 col-lg-6 order-first order-lg-2 fade-in">
          <div class="partner-text textbox">
            <h1>Unser starker Partner</h1>
            <p>Wir bei Haarlem Friseure legen einen besonderen Wert darauf, unseren Kunden und Kundinnen nur Produkte
              von Marken zu übergeben, welche von uns persönlich ausgewählt und beurteilt wurden.</p>
            <p>Ob Haarfarbe, Haarpflege oder Styling-Produkte: Bei unseren Kooperationen finden Sie zu jeder Gelegenheit
              das passende Produkt.</p>
          </div>
        </div>
        <!--
        <div class="col-12 col-lg-2 order-lg-3 slide-in from-right">
          <div class="products">
            <img src="../../../assets/images/produkte.png" alt="Produkt von Tigi">
          </div>
        </div>
        -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Partner",
}
</script>

<style scoped lang="scss">
@import 'src/assets/scss/imports';

.partner {
  h1 {
    text-transform: uppercase;
    letter-spacing: 4px;
  }

  .logo {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    @include media-breakpoint-down(md) {
      margin-top: 30px;
      max-width: 60%;
    }
  }

  .partner-text {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    @include media-breakpoint-down(md) {
      text-align: center;
    }
  }

  .products {
    position: relative;
    max-width: 75%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    @include media-breakpoint-down(md) {
      display: none;
    }
  }
}
</style>
